import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { GetActiveCustomerQuery } from '../../common/generated-types';
import { GET_ACTIVE_CUSTOMER } from '../../common/graphql/documents.graphql';
import { DataService } from '../../core/providers/data/data.service';

@Injectable({ providedIn: 'root' })
export class AccountGuard {
    private dataService = inject(DataService);
    private router = inject(Router);
    private platformId = inject(PLATFORM_ID);

    canActivate(): Observable<boolean | UrlTree> {
        // Skip auth check during SSR - allow access, will check on client hydration
        if (!isPlatformBrowser(this.platformId)) {
            return of(true);
        }

        return this.dataService
            .query<GetActiveCustomerQuery>(GET_ACTIVE_CUSTOMER, {}, 'network-only')
            .pipe(map((data) => (data.activeCustomer ? true : this.router.parseUrl('/'))));
    }
}
